<template>
  <div class="actions flex gap-4 flex-none">
    <etg-button type="icon" size="small" icon="arrow-left" @click="emit('prev')" />
    <etg-button type="icon" size="small" icon="arrow-right" @click="emit('next')" />
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits<{ prev: []; next: [] }>()
</script>
